import React from 'react';

import {Headline} from 'src/admin-rights-service/components/headline';
import {SkeletonItem} from 'src/components/skeleton';

import {Group} from '@pb/kit-component-group';


export const AssignedUsersHeadlineSkeleton = () => (
    <Headline
        prefix={(
            <Group>
                <SkeletonItem width={130} height={32}/>
                <SkeletonItem width={300} height={32}/>
            </Group>
        )}
        header=""
        actionButtons={
            <SkeletonItem width={100} height={32}/>
        }
    />
);
